import { BadgeSlider } from './BadgeSlider.component';

export { BadgeSlider };
